import(/* webpackMode: "eager" */ "/tmp/8de75f0375efc70/app/[locale]/error.tsx");
